import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { levels } from '../data/levels';
import styles from './LevelDetail.module.css';

const LevelDetail: React.FC = () => {
  const navigate = useNavigate();
  const { levelId } = useParams<{ levelId: string }>();
  const level = levels.find((l) => l.id === levelId);

  if (!level) {
    return (
      <div className={styles.container}>
        <header className={styles.header}>
          <button className={styles.backButton} onClick={() => navigate('/map')}>
            ← 返回选关
          </button>
          <h1 className={styles.title}>关卡未找到</h1>
        </header>
        <p className={styles.text}>请返回关卡地图重新选择。</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <button className={styles.backButton} onClick={() => navigate('/map')}>
          ← 返回选关
        </button>
        <h1 className={styles.title}>{level.title}</h1>
      </header>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>关卡目标</h2>
        <p className={styles.text}>{level.description}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>本关知识点</h2>
        <ul className={styles.knowledgeList}>
          {level.knowledgePoints.map((point, idx) => (
            <li key={idx}>{point}</li>
          ))}
        </ul>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>预计耗时</h2>
        <div className={styles.timeEstimate}>
          <span className={styles.timeIcon}>⏱</span>
          <span>{level.estimatedTime} 分钟</span>
        </div>
      </section>

      {level.riskWarning && (
        <section className={`${styles.section} ${styles.riskSection}`}>
          <h2 className={styles.sectionTitle}>风险边界提示</h2>
          <p className={styles.riskText}>{level.riskWarning}</p>
        </section>
      )}

      <section className={styles.ctaSection}>
        <button className={styles.startButton} onClick={() => navigate(`/cards/${level.id}`)}>
          开始学习
        </button>
      </section>
    </div>
  );
};

export default LevelDetail;
